enum AddOnTypeEnum {
  VERIFIED = 'verified',
  CERTIFIED = 'certified',
}

const softwareEscrowAddons = [
  {
    type: AddOnTypeEnum.VERIFIED,
    name: 'Verified level',
    description: 'Automated review of supported materials and any updates made to them.',
    price: 29,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
    benefits: {
      heading: 'Checks everything under Validated, plus:',
      items: ['Content profiles — assets size, etc.', 'Development updates', 'Login verification tests'],
    },
  },
  {
    type: AddOnTypeEnum.CERTIFIED,
    name: 'Certified level',
    description: 'In-depth human analyses that give you complete assurance of continuity.',
    price: 329,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
    benefits: {
      heading: 'Checks everything under Verified, plus:',
      items: ['Full software build tests', 'Application deployment validation', 'Admin access tests'],
    },
  },
];

const softwareEscrowAddonsDictionary = softwareEscrowAddons.reduce(
  (acc, addOn) => {
    acc[addOn.type] = addOn;
    return acc;
  },
  {} as Record<AddOnTypeEnum, (typeof softwareEscrowAddons)[0]>,
);

const saasEscrowAddons = [
  {
    type: AddOnTypeEnum.VERIFIED,
    name: 'Verified level',
    description: 'Automated review of supported materials and any updates made to them.',
    price: 99,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
    benefits: {
      heading: 'Checks everything under Validated, plus:',
      items: ['Content profiles — assets size, etc.', 'Development updates', 'Login verification tests'],
    },
  },
  {
    type: AddOnTypeEnum.CERTIFIED,
    name: 'Certified level',
    description: 'In-depth human analyses that give you complete assurance of continuity.',
    price: 449,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
    benefits: {
      heading: 'Checks everything under Verified, plus:',
      items: ['Full software build tests', 'Application deployment validation', 'Admin access tests'],
    },
  },
];

const saasEscrowAddonsDictionary = saasEscrowAddons.reduce(
  (acc, addOn) => {
    acc[addOn.type] = addOn;
    return acc;
  },
  {} as Record<AddOnTypeEnum, (typeof saasEscrowAddons)[0]>,
);

const continuityEscrowAddons = [
  {
    type: AddOnTypeEnum.VERIFIED,
    name: 'Verified level',
    description: 'Manual inspection of the escrow agent’s access to the providers’ accounts.',
    price: 99,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
  },
  {
    type: AddOnTypeEnum.CERTIFIED,
    name: 'Certified level',
    description: 'In-depth human analyses that give you complete assurance of continuity.',
    price: 449,
    subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
  },
];

const backupAutomatedAddon = {
  type: AddOnTypeEnum.VERIFIED,
  name: 'Verified level',
  description: 'Automated review of supported assets and any updates made to them.',
  price: 99,
  subscriptionText: 'Added to the owner’s subscription. Regional pricing may apply.',
  benefits: {
    heading: 'Checks everything under Validated, plus:',
    items: ['Content profiles — asset size, etc.', 'Development updates', 'Login verification tests'],
  },
};

const continuityEscrowAddonsDictionary = continuityEscrowAddons.reduce(
  (acc, addOn) => {
    acc[addOn.type] = addOn;
    return acc;
  },
  {} as Record<AddOnTypeEnum, (typeof continuityEscrowAddons)[0]>,
);

export {
  AddOnTypeEnum,
  softwareEscrowAddons,
  softwareEscrowAddonsDictionary,
  continuityEscrowAddons,
  continuityEscrowAddonsDictionary,
  saasEscrowAddons,
  saasEscrowAddonsDictionary,
  backupAutomatedAddon,
};
